import Science from "@mui/icons-material/Science";
import { Typography } from "@mui/material";
import { IssueCount } from "components/IssueCount";
import pluralize from "pluralize";
import { Link } from "react-router-dom";

import { BaseLink } from "./BaseLink";

interface InventoryLinkProps {
  name: string;
  issueCount: number;
  link: string;
}

export const InventoryLink = ({ name, link, issueCount }: InventoryLinkProps) => {
  const linkContent =
    issueCount === 0 ? (
      <>
        <Science fontSize="small" sx={{ mr: 1 }} />
        View your{" "}
        <Link
          to={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", overflow: "hidden" }}
        >
          <Typography noWrap>{name}</Typography>
        </Link>
        {` inventory entry`}
      </>
    ) : (
      <>
        Fix&nbsp;
        <IssueCount issueCount={issueCount} />
        &nbsp;
        {pluralize("issue", issueCount)} in the inventory entry for{" "}
        <Link
          to={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", overflow: "hidden" }}
        >
          <Typography noWrap>{name}</Typography>
        </Link>
      </>
    );

  return <BaseLink linkContent={linkContent} link={link} issueCount={issueCount} />;
};
